<template>
  <section class="portofolio">
    <Hero />
    <Items />
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Items from "@/components/views/portofolio/items.vue";
import Hero from "@/components/views/portofolio/hero.vue";
export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "Portofolio | Zoinix Inter Technology",
      url: "https://zoinix.com/portofolio",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Items, Hero },
});
</script>
